import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Popconfirm, message, Modal, Row,Col, Input, Spin, Table } from 'antd';
import TableC from '../../basicElement/TableC';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import Filter from './CRCFilter';
import Update from './CRCUpdate';
import PreTransferFte from './components/PreTransferFte';
import RefuseProcess from './components/RefuseProcess';
import TransferProcess from './components/TransferProcess';
import EmployeeDetail from '../require/components/EmployeeDetail';
import ViewRefused from './components/ViewRefused';
import ViewReport from './components/ViewReport';
import { convertOption } from '../../shared/selectFn';
import ExecuteSider from '../../execute/ExecuteSider';
import UserSider from '../UserSider';
import PMreport from './components/PMReport';

const { TextArea } = Input;
class CRCTransfer extends Component {
    state = {
        loading: false,
        pagination: {
            current: 1,
            pageSize: 10,
        },
        dataList: [],
        searchArray: {},
        sortParams: {},
        businessList: [],
        visible:false,
        requirementId:null,
        recallRemark:null,
    }

    componentDidMount() {
        const param = this.props.match ? this.props.match.params.handoverId : '';
        if (param) {
            if (param.indexOf('code_') > -1) {
                const { searchArray } = this.state;
                searchArray.handoverCode = param.slice(5);
                this.setState({ searchArray }, () => {
                    this.loadData();
                });
            } else {
                this.setState({ handoverId: param }, () => {
                    this.loadData();
                });
            }
        } else {
            this.loadData();
        }
        const { invId } = sessionStorage;
        if (invId > 0) {
            this.queryInvestigationStageByInvId(invId);
        }
        this.queryBusiness();
    }

    reload = (params = {}) => {
        const { pagination } = this.state;
        let offset;
        if (params.noPage) {
            offset = null;
        } else {
            offset = pagination.current;
        }
        this.loadData({
            offset: offset,
            ...params,
        });
    }

    isAssignUser = (assignedUserList) => {
        const userId = sessionStorage.userId;
        let isAssign = false;
        assignedUserList.map((value, index) => {
            if (value.userId == userId) {
                isAssign = true;
            }
        })
        return isAssign;
    }

    export = () => {
        const { searchArray, pagination, sort, direction } = this.state;
        if (sort && direction) {
            searchArray.sort = sort;
            searchArray.direction = direction;
        }

        const options = {
            method: 'POST',
            url: API_URL.execute.exportList,
            data: {
                ...searchArray,
                offset: 1,
                limit: pagination.total || 0,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
            },
        };
        $.sendRequest(options);
    }

    loadData = (params = {}) => {
        this.setState({ loading: true });
        const { sortParams, searchArray, handoverId, pagination } = this.state;
        const { current, pageSize } = pagination;
        const options = {
            method: 'POST',
            url: API_URL.execute.queryHandoverList,
            data: {
                ...searchArray,
                ...params,
                ...sortParams,
                offset: current,
                limit: pageSize,
                handoverId,
            },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                const { handoverList } = data || {};
                const { datas = [], totalCount = 0 } = handoverList || {};
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    dataList: datas,
                    pagination,
                    handoverId: '',
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = (params = {}) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchArray: params,
        }, () => {
            this.loadData();
        });
    }

    queryBusiness = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { typeConfigureList = [] } = res;
            const businessList = (typeConfigureList || []).map(convertOption('typeConfigureId', 'typeValue'));
            this.setState({ businessList });
        });
    }

    queryInvestigationStageByInvId = (investigationId, callback) => {
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationStageByInvId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                this.setState({
                    invStageList: data,
                }, () => {
                    callback && this.canEditByInvStatus(callback);
                });
            }
        };
        $.sendRequest(options);
    }

    canEditByInvStatus = (callback) => {
        const { invStageList: data = [] } = this.state;
        const canEdit = !(data || []).some(i => {
            if (i.operation === 'INVESTIGATION_LEVEL_LOWEST') {
                message.error('项目到达“项目终止”阶段，不可调整项目相关数据！');
                return true;
            } else if (i.operation === 'INVESTIGATION_DATA_LOCK') {
                message.error('项目到达“项目关闭”阶段，不可调整项目相关数据！');
                return true;
            } else if(i.operation === 'TERMINATED_BEFORE_CONTRACT'){
                message.error('项目已在服务合同签署前终止，不可调整项目相关数据');
                return true;
            } else if (i.operation === 'BUSINESS_DATA_ARCHIVING') {
                message.error('项目到达“业务数据归档”阶段，不可编辑项目相关数据');
                return true;
            }
            return false;
        });
        if (canEdit) {
            callback();
        }
    }

    getColumns = () => {
        const columnNames = [];
        const { userId, curRole } = sessionStorage;
        columnNames.push({
            title: '交接编号',
            dataIndex: 'requirementCode',
            key: 'requirementCode',
            width: 100,
            sorter: true,
        }, {
            title: '项目编号',
            dataIndex: 'investigationCode',
            key: 'investigationCode',
            width: 120,
            sorter: true,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 120,
        }, {
            title: '业务线',
            dataIndex: 'lineOfBusinessString',
            key: 'lineOfBusinessString',
            width: 80,
        }, {
            title: '执行业务线二级分类',
            dataIndex: 'secondLineNames',
            key: 'secondLineNames',
            width: 100,
        }, {
            title: '中心编号',
            dataIndex: 'investigationSiteCode',
            key: 'investigationSiteCode',
            width: 100,
            sorter: true,
            sortType: 'common',
        }, {
            title: '中心名称',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            width: 120,
        }, {
            title: '院区',
            dataIndex: 'courtyardArea',
            key: 'courtyardArea',
            width: 120,
        }, {
            title: '科室',
            dataIndex: 'departmentName',
            key: 'departmentName',
            width: 120,
        }, {
            title: '城市',
            dataIndex: 'city',
            key: 'city',
            width: 80,
        }, {
            title: '预计要交接的FTE',
            dataIndex: 'transferFte',
            key: 'transferFte',
            width: 80,
            render: (text, record) => {
                const { estimateHandOverFtes } = record;
                const fte = (estimateHandOverFtes || []).reduce((acc, cur) => acc + cur.planFte, 0);
                return <a onClick={() => this.showPreTransferFte(record)}>{(fte || 0).toFixed(2)}</a>;
            }
        }, {
            title: '交接人',
            dataIndex: 'handoverUser',
            key: 'handoverUser',
            width: 80,
        }, {
            title: '接收人',
            dataIndex: 'assignedUsers',
            key: 'assignedUsers',
            width: 80,
            render: (text, record) => {
                if (!record.assignedUsers) return;
                let users = record.assignedUsers.split('//');
                if (curRole == "CRC") {
                    return (
                        <span>
                            {
                                users.map((user, i) => {
                                    let u = user.split(',');
                                    return (
                                        <span key={user + i}>
                                            {u[2]}{users.length > 1 ? ';' : ''}
                                        </span>
                                    );
                                })
                            }
                        </span>
                    )
                } else {
                    return (
                        <span>
                            {
                                users.map((user, i) => {
                                    let u = user.split(',');
                                    return (
                                        <a
                                            key={user + i}
                                            onClick={() => this.showEmployeeDetail(u[0], u[1], u[2])}
                                        >
                                            {u[2]}{users.length > 1 ? ';' : ''}
                                        </a>
                                    );
                                })
                            }
                        </span>
                    )
                }
            }
        }, {
            title: '人员要求',
            dataIndex: 'requirementComment',
            key: 'requirementComment',
            width: 100,
        }, {
            title: '交接原因',
            dataIndex: 'handoverReasonShow',
            key: 'handoverReasonShow',
            width: 100,
        },{
            title: '发起人',
            dataIndex: 'requireUser',
            key: 'requireUser',
            width: 80,
        }, {
            title: '处理人',
            dataIndex: 'assignUserName',
            key: 'assignUserName',
            width: 80,
        }, {
            title: '状态',
            dataIndex: 'status',
            key: 'status',
            width: 80,
            render: (text, record) => {
                let status;
                if (record.status === 'NEW') {
                    status = '新建';
                } else if (record.status === 'ASSIGNED') {
                    status = '预分配';
                } else if (record.status === 'REASSIGNED') {
                    status = '重新分配';
                } else if (record.status === 'REJECTED') {
                    status = '被拒绝';
                } else if (record.status === 'HANDOVER_RECALL') {
                    status = '已撤回';
                } else if (record.status === 'UNDERWAY') {
                    status = '进行中';
                } else if (record.status === 'RETURNED') {
                    status = '进行中';
                } else if (record.status === 'RECEIVED') {
                    status = '已提交';
                } else if (record.status === 'INACTIVE') {
                    status = '无效的';
                } else if (record.status === 'ACTIVE') {
                    status = '已完成';
                } else {
                    status = record.status;
                }
                return (
                    <span>{status}</span>
                );
            },
        }, {
            title: '操作',
            key: 'operation',
            fixed: 'right',
            width: 100,
            render: (text, record) => {
                const { src } = this.props;
                const { status, cityId, provinceId, requirementId, handoverUserId, assignedUserList, investigationId, handoverReasonShow } = record;
                const params = { workCityId: cityId, provinceId, requirementId ,status };
                if ((curRole == "PM" || curRole == "PA") && src == "Execute") {
                    if (status == "NEW") {
                        return (
                            <span>
                                <a onClick={() => this.update(record, 'edit')}>修改</a>
                                <span className="ant-divider" />
                                <a onClick={() => this.canEditByInvStatus(() => this.delModel(requirementId))}>删除</a>
                            </span>
                        );
                    } else if (status == "ASSIGNED" || status == "REASSIGNED") {
                        return (
                            <span>
                                <Popconfirm title='确定要分配吗?' onConfirm={() => this.canEditByInvStatus(() => this.confirmProcess(requirementId))} okText="确定" cancelText="取消">
                                    <a>确认分配</a>
                                </Popconfirm>
                                <span className="ant-divider" />
                                <a onClick={() => this.canEditByInvStatus(() => this.refuseProcess(requirementId))}>拒绝分配</a>
                            </span>
                        );
                    } else if (status == "REJECTED") {
                        return (
                            <a onClick={() => this.canEditByInvStatus(() => this.delModel(requirementId))}>删除</a>
                        );
                    } else if (status == "HANDOVER_RECALL") {
                        return (
                            <a onClick={() => this.canEditByInvStatus(() => this.delModel(requirementId))}>删除</a>
                        );
                    } else if (status == "UNDERWAY" || status == "RETURNED" || status == "RECEIVED" || status == "ACTIVE") {
                        return (
                            <span>
                                <a onClick={() => this.viewReport(requirementId)}>查看报告</a>
                                {
                                    (status == "UNDERWAY" || status == "RETURNED") && 
                                    <span className="ant-divider" />
                                }
                                {
                                    (status == "UNDERWAY" || status == "RETURNED") && 
                                    <a onClick={() => this.recallModel(requirementId)}>撤回</a>
                                }
                                {
                                    status == "UNDERWAY" && 
                                    <span className="ant-divider" />
                                }
                                {
                                    status == "UNDERWAY" && 
                                    <a onClick={() => this.viewReport(requirementId, true)}>填写报告</a>
                                }
                            </span>
                        );
                    }
                } else if (curRole == "CRC") {
                    if ((handoverUserId == userId) || (assignedUserList && this.isAssignUser(assignedUserList))) {//用户为交接人/接收人
                        if (status == "NEW" || status == "ASSIGNED" || status == "REJECTED" || status == "REASSIGNED") {
                            return <span>-</span>;
                        } else if (status == "RETURNED" || status == "UNDERWAY") {
                            return (
                                <span>
                                    <a onClick={() => this.viewReport(requirementId, true)}>填写报告</a>
                                    <span className="ant-divider" />
                                    <a onClick={() => this.viewRefused(requirementId)}>查看打回记录</a>
                                </span>
                            );
                        } else if (status == "RECEIVED" || status == "ACTIVE") {
                            return <a onClick={() => this.viewReport(requirementId)}>查看报告</a>;
                        }
                    } else {
                        return <span>-</span>;
                    }
                } else if (curRole == "CRCM" || curRole == "CRCC" || curRole == "BO" || curRole == "CSAL" || curRole == "BDM" || curRole == "PML" || curRole == "CTA" || curRole == "VP" || curRole == "FIN" || ((curRole == "PM" || curRole == "PA") && src == "User")) {
                    if (curRole != "CTA" && curRole != "VP" && curRole != "FIN" && curRole != "BDM" && curRole != "PML") {
                        if (status == "NEW") {
                            return <a onClick={() => this.queryInvestigationStageByInvId(investigationId, () => this.process({...params,handoverReasonShow}, "handle"))}>处理</a>;
                        } else if (status === 'REJECTED') {
                            return <a onClick={() => this.queryInvestigationStageByInvId(investigationId, () => this.process({...params,handoverReasonShow}, "rehandle"))}>重新处理</a>;
                        } else if ((status === 'ASSIGNED' || status === 'REASSIGNED')) {
                            return <span>-</span>;
                        }
                    }
                    if (status === 'UNDERWAY' || status === 'RETURNED' || status === 'RECEIVED' || status === 'ACTIVE') {
                        return (
                            <span>
                                <a onClick={() => this.viewReport(requirementId)}>查看报告</a>
                            </span>
                        );
                    }
                    if ( status == "HANDOVER_RECALL" && (curRole == "CRCM" || curRole == "CRCC" || curRole == "BO")){
                        return <a onClick={() => this.queryInvestigationStageByInvId(investigationId, () => this.process({...params,handoverReasonShow}, "rehandle"))}>重新处理</a>;
                    }
                } else {
                    return <span>-</span>;
                }
            },
        });
        return columnNames;
    }

    confirmProcess = requirementId => {
        const options = {
            method: 'POST',
            url: API_URL.user.confirmRequirement,
            dataType: 'json',
            data: { requirementId },
            doneResult: () => {
                message.success('操作成功');
                this.reload();
            }
        };
        $.sendRequest(options);
    }

    refuseProcess = id => {
        this.refuseProcessRef.show(id);
    }

    viewReport = (id, isEdit) => {
        this.viewReportRef.show(id, isEdit);
    }

    viewRefused = id => {
        this.viewRefusedRef.show(id);
    }

    showPreTransferFte = (record) => {
        this.preTransferRef.show(record);
    }

    getDataSource = () => {
        const records = [];
        const { dataList, pagination } = this.state;
        //let key = 0;
        dataList.map((dataItem, i) => {
            records.push({
                key: dataItem.requirementId,
                index: ((pagination.current - 1) || 0) * 15 + i + 1,
                requirementCode: dataItem.requirementCode,
                investigationCode: dataItem.site.investigation.investigationCode,
                investigationName: dataItem.site.investigation.investigationName,
                investigationId: dataItem.site.investigation.investigationId,
                investigationSiteId: dataItem.site.investigationSiteId,
                investigationSiteName: dataItem.site.investigationSiteName,
                investigationSiteCode: dataItem.site.investigationSiteCode,
                city: dataItem.site.city,
                cityId: dataItem.site.cityId,
                provinceId: dataItem.site.provinceId,
                handoverUser: dataItem.handoverUser,
                handoverUserCode: dataItem.handoverUserCode,
                handoverUserId: dataItem.handoverUserId,
                assignedUserList: dataItem.assignedUserList,
                userCompellation: dataItem.userCompellation,
                requirementComment: dataItem.requirementComment,
                requireUser: dataItem.requireUser,
                assignedUsers: dataItem.assignedUsers,
                status: dataItem.status,
                requirementId: dataItem.requirementId,
                assignUserName: dataItem.assignUserName,
                lineOfBusinessString: dataItem.lineOfBusinessString,
                secondLineNames: dataItem.secondLineNames,
                estimateHandOverFtes: dataItem.estimateHandOverFtes,
                proCompTime: dataItem.prospectiveCompleteTime,
                estimateCompletedTime: dataItem.estimateCompletedTime,
                handoverReasonId:dataItem.handoverReasonId,
                handoverReasonValue:dataItem.handoverReasonValue,
                handoverReasonRemark:dataItem.handoverReasonRemark,
                handoverReasonShow:dataItem.handoverReasonShow,
                courtyardArea:dataItem.site.courtyardArea,
                departmentName:dataItem.site.departmentName
            });
        });
        return records;
    }

    update = (record, type) => {
        this.canEditByInvStatus(() => this.updateRef.show(record, type));
    }

    delModel = (requirementId) =>{
        const _this = this
        Modal.confirm({
            title: '确定要删除该CRC交接分配吗',
            onOk() {
                _this.handleDel(requirementId)
            },
            onCancel() {},
            cancelText:'取消',
            okText:'确认',
        });
    }

    recallModel = (requirementId) =>{
        const _this = this
        Modal.confirm({
            title: '确定要撤回该CRC交接分配吗',
            onOk() {
                _this.setState({requirementId, visible:true})
            },
            onCancel() {},
            cancelText:'取消',
            okText:'确认',
        });
    }

    handleDel = (requirementId) => {
        const options = {
            method: 'POST',
            url: API_URL.execute.deleteHandover,
            data: { requirementId },
            dataType: 'json',
            doneResult: () => {
                this.loadData();
            },
        };
        $.sendRequest(options);
    }

    handleRecall = () => {
        const { requirementId , recallRemark , visible } = this.state;
        if(recallRemark){
            const options = {
                method: 'POST',
                url: API_URL.execute.recallHandover,
                data: { requirementId , recallRemark },
                dataType: 'json',
                doneResult: () => {
                    this.setState({ requirementId:null, recallRemark:null, visible:false})
                    this.loadData();
                },
            };
            $.sendRequest(options);
        }else{
            message.warning('请输入撤回分配理由！')
        }
        
    }

    showEmployeeDetail = (id, code, name) => {
        this.employeeDetailRef.show(id, code, name);
    }

    process = (params, handle) => {
        this.processModalRef.show(params, handle);
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { src, match } = this.props;
        const { loading, dataList, pagination, sortParams, businessList, visible, recallRemark } = this.state;
        const scrollX = this.getColumns().reduce((acc, i) => acc + i.width, 0);
        // const yscroll = dataList.length > 0 ? document.documentElement.clientHeight - 460 : false;
        return (
            <div>
                <Filter
                    search={this.search}
                    update={this.update}
                    export={this.export}
                    src={src}
                    businessList={businessList}
                    handoverCode={match.params.handoverId}
                />
                <TableC
                    columns={this.getColumns()}
                    data={this.getDataSource()}
                    loading={loading}
                    scrollY={500}
                    sortParams={sortParams}
                    onChange={this.handleTableChange}
                    pagination={pagination}
                    rowKey="requirementId"
                />
                <Update
                    ref={el => { this.updateRef = el; }}
                    reload={this.reload}
                />
                <TransferProcess
                    ref={el => this.processModalRef = el}
                    reload={this.reload}
                    showEmployeeDetail={this.showEmployeeDetail}
                />
                <RefuseProcess
                    ref={el => { this.refuseProcessRef = el; }}
                    reload={this.reload}
                />
                <EmployeeDetail
                    ref={el => { this.employeeDetailRef = el; }}
                    reload={this.reload}
                />
                <ViewReport
                    ref={el => { this.viewReportRef = el; }}
                    canEditByInvStatus={this.canEditByInvStatus}
                    reload={this.reload}
                    src={src}
                />
                <ViewRefused ref={el => this.viewRefusedRef = el } />
                <PreTransferFte ref={el => this.preTransferRef = el } />
                <Modal 
                    title="撤回交接分配"
                    visible={visible}
                    onOk={this.handleRecall}
                    onCancel={() => this.setState({visible:false})}
                    >
                    <Row style={{ paddingRight: 20 }}>
                        <Col span={6} style={{ textAlign: 'right' }}><span style={{color: 'red'}}>*</span>撤回分配理由：</Col>
                        <Col span={17} offset={1}>
                            <TextArea
                                placeholder="请输入"
                                value={recallRemark}
                                autosize={{ minRows: 3, maxRows: 6 }}
                                onChange={e => this.setState( {recallRemark: e.target.value} )}
                            />
                        </Col>
                    </Row>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = function (store) {
    return {
        searchParams: store.executeState.searchParams,
    };
};

export default connect(mapStateToProps)(CRCTransfer);


// WEBPACK FOOTER //
// ./src/components/user/transfer/CRCTransfer.js